module.exports = __webpack_public_path__ + "static/background-9eda7e937f9e3dbc08a0528a1725c27b.png";